import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const SEO_PAGES = [
  { path: "/timesheet-app-nz", label: "NZ Timesheet App" },
  { path: "/job-management-nz", label: "Job Management Software NZ" },
  { path: "/civil-construction-software-nz", label: "Civil Construction Software NZ" },
  { path: "/sssp-generator-nz", label: "SSSP Generator NZ" },
  { path: "/safety-management-nz", label: "Safety Management NZ" },
  { path: "/fleet-management-nz", label: "Fleet Management NZ" },
  { path: "/simpro-alternative-nz", label: "Simpro Alternative NZ" },
  { path: "/payroll-software-civil-nz", label: "Payroll Software for Civil Contractors NZ" },
  { path: "/pre-start-checklist-app-nz", label: "Pre-Start Checklist App NZ" },
  { path: "/xero-timesheet-integration-nz", label: "Xero Timesheet Integration NZ" },
  { path: "/civil-estimating-software-nz", label: "Civil Estimating Software NZ" },
  { path: "/construction-takeoff-software-nz", label: "Construction Takeoff Software NZ" },
  { path: "/ai-construction-plan-reader", label: "AI Construction Plan Reader" },
  { path: "/drainage-estimating-software", label: "Drainage Estimating Software" },
  { path: "/earthworks-estimating-software", label: "Earthworks Estimating Software" },
  { path: "/civil-job-costing-software-nz", label: "Civil Job Costing Software NZ" },
  { path: "/civil-crew-scheduling-software-nz", label: "Crew Scheduling Software NZ" },
  { path: "/construction-qa-software-nz", label: "Construction QA Software NZ" },
  { path: "/resources", label: "Fieldlink Civil Hub — Free Calculators" },
];

// Internal-linking block shown on every marketing/SEO page. Cross-links every
// keyword page to every other one so PageRank flows through the cluster.
export function RelatedPages({ current }) {
  const links = SEO_PAGES.filter((p) => p.path !== current);
  return (
    <section className="max-w-6xl mx-auto px-6 md:px-12 py-14 border-t border-[#cbd3d5]">
      <h2 className="font-display font-black uppercase tracking-tight text-2xl mb-6">More from Fieldlink</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {links.map((p) => (
          <Link
            key={p.path}
            to={p.path}
            className="group flex min-h-14 items-center justify-between gap-4 rounded-md border border-[#cbd3d5] bg-white px-4 py-3 text-sm font-semibold text-[#142635] shadow-sm transition-colors hover:border-[#a63c0b] hover:bg-[#fff3eb] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#a63c0b]"
            data-testid={`related-${p.path.replace(/\//g, "")}`}
          >
            {p.label}
            <ArrowRight className="w-4 h-4 shrink-0 text-[#52616c] group-hover:text-[#a63c0b] transition-colors" />
          </Link>
        ))}
      </div>
    </section>
  );
}

// Shared FAQ block for SEO pages — pairs with FAQPage JSON-LD passed to <SEO/>.
export function SeoFaq({ faqs }) {
  return (
    <section className="max-w-3xl mx-auto px-6 md:px-12 py-16">
      <h2 className="font-display font-black uppercase tracking-tight text-3xl mb-8">Common questions</h2>
      <div className="space-y-6">
        {faqs.map((f) => (
          <div key={f.q} className="border-l-4 border-[#FF5F15] pl-5">
            <h3 className="font-display font-bold uppercase tracking-tight text-lg">{f.q}</h3>
            <p className="text-zinc-300 leading-relaxed mt-1.5 text-sm">{f.a}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export function faqJsonLd(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}
